import { createFileRoute } from "@tanstack/react-router"
import LoisUsageAnalyticsPage from "@/components/coreAnalytics/lois/LoisUsageAnalyticsPage"

export const Route = createFileRoute("/core/analytics/lois-usage")({
  component: LoisUsageAnalyticsPage
})
